module.exports = __webpack_public_path__ + "static/06-6e6e8170310c52911f1e07174918cf8c.png";